export { OnChange } from './decorators';
export { LinkedList } from './linked-list.class';
export { isBs3 } from './theme-provider';
export { Trigger } from './trigger.class';
export { Utils } from './utils.class';
export { setTheme } from './theme-provider';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/ngx-bootstrap/utils/index.js
// module id = ../../../../ngx-bootstrap/utils/index.js
// module chunks = 4